import { COLORS } from '@shared/config/colors/colors';
import { NetworkBase } from '@shared/ui/network-state-new/network-base/network-base';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;

    & .rf-search {
        flex-shrink: 0;
    }
`;

export const StyledNetworkBase = styled(NetworkBase)`
    padding: 32px;
    border: 1px solid ${COLORS.neutral_20};
    border-radius: 16px;
`;

export const EmptySearch = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 32px;
`;
